import React, { useCallback } from 'react'
import styled from '@emotion/styled'
import { CollateralBasketDetail } from 'api'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ReadOnlyCollateralBasketDetailsDialog } from './ReadOnlyCollateralBasketDetailsDialog'
import { ModalConsumerProps, withModal } from '../modal'
import { createCollateralBasketDetailSelector } from 'selectors/collateralBasketSelectors'
import { leftNavigationIconSet } from '../leftNavigation/leftNavigationIcons'

type ReadOnlyCollateralBasketDetailsButtonProps = OwnProps & StateProps

interface OwnProps extends ModalConsumerProps {
  collateralBasketId?: string
  'data-test-id'?: string
}

interface StateProps {
  collateralBasketDetail: CollateralBasketDetail | null
}

interface DispatchProps {}

const basketIdSelector = (_: {}, props: ReadOnlyCollateralBasketDetailsButtonProps) => props.collateralBasketId

const mapStateToProps = createStructuredSelector({
  collateralBasketDetail: createCollateralBasketDetailSelector(basketIdSelector)
})

export const BasketIconWrapper = styled.div`
  width: 28px;
  display: flex;
  cursor: pointer;
`

const ReadOnlyCollateralBasketDetailsButtonComponent: React.FunctionComponent<ReadOnlyCollateralBasketDetailsButtonProps> = props => {
  const { showModal, collateralBasketDetail, 'data-test-id': dataTestId } = props

  if (!collateralBasketDetail) {
    return <BasketIconWrapper data-test-id={dataTestId} />
  }

  const showBasketDetails = useCallback(() => {
    showModal(<ReadOnlyCollateralBasketDetailsDialog collateralBasketDetail={collateralBasketDetail} />)
  }, [collateralBasketDetail, showModal])

  return (
    <BasketIconWrapper data-test-id={dataTestId} onClick={showBasketDetails}>
      {leftNavigationIconSet.basketIcon}
    </BasketIconWrapper>
  )
}

export const ReadOnlyCollateralBasketDetailsButton = withModal(
  connect<StateProps, DispatchProps, OwnProps>(mapStateToProps)(ReadOnlyCollateralBasketDetailsButtonComponent)
)
